document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-tws-premium-home]").forEach((section) => {
    const filters = section.querySelectorAll("[data-tws-filter]");
    const cards = section.querySelectorAll("[data-tws-category]");

    filters.forEach((filterButton) => {
      filterButton.addEventListener("click", () => {
        const filter = filterButton.getAttribute("data-tws-filter") || "all";

        filters.forEach((button) => {
          button.classList.toggle("is-active", button === filterButton);
        });

        cards.forEach((card) => {
          const categories = card.getAttribute("data-tws-category") || "";
          card.hidden = filter !== "all" && !categories.split(" ").includes(filter);
        });
      });
    });
  });

  document.querySelectorAll("[data-tws-premium-product]").forEach((section) => {
    const variantSelect = section.querySelector("[data-tws-variant-select]");

    if (!variantSelect) {
      return;
    }

    const price = section.querySelector("[data-tws-product-price]");
    const compare = section.querySelector("[data-tws-product-compare]");
    const sku = section.querySelector("[data-tws-product-sku]");
    const status = section.querySelector("[data-tws-product-status]");
    const addToCart = section.querySelector("[data-tws-atc]");

    const updateProductState = () => {
      const selectedOption = variantSelect.selectedOptions[0];

      if (!selectedOption) {
        return;
      }

      if (price && selectedOption.dataset.price) {
        price.textContent = selectedOption.dataset.price;
      }

      if (compare) {
        const compareText = selectedOption.dataset.compareAt || "";
        compare.textContent = compareText;
        compare.hidden = compareText.length === 0;
      }

      if (sku) {
        const skuText = selectedOption.dataset.sku || "";
        sku.textContent = skuText ? `SKU ${skuText}` : "";
        sku.hidden = skuText.length === 0;
      }

      const isAvailable = selectedOption.dataset.available === "true";

      if (status) {
        status.textContent = isAvailable
          ? status.dataset.availableText || "Available"
          : status.dataset.soldOutText || "Currently unavailable";
        status.classList.toggle("is-sold-out", !isAvailable);
      }

      if (addToCart) {
        addToCart.disabled = !isAvailable;
        addToCart.textContent = isAvailable
          ? addToCart.dataset.availableText || "Add to bag"
          : addToCart.dataset.soldOutText || "Sold out";
      }

      if (selectedOption.value && window.history?.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set("variant", selectedOption.value);
        window.history.replaceState({}, "", url.toString());
      }
    };

    variantSelect.addEventListener("change", updateProductState);
  });
});
